import router from '@router';
import config from '@config';
import store from '@store';
import programUrl from '@config/program-url';
import { $toast } from "$use-in-vue/mint-ui/toast";

const officeTabBar = {
  list: {
    items: [{
      content: {
        value: '首页',
        fontSize: 13,
        color:'#4b4b4b'
      },
      icon: {
        src: `${config.path.static}/img/tab-bar/office/home.png`,
        activeSrc: `${config.path.static}/img/tab-bar/office/home-a.png`,
        style: 'width:23px;',
        direction: 'top'
      },
      to() {
        location.href = programUrl['gou-wu-bao'];
      },
      className: 'bc-pd-5'
    },
    //   {
    //   content: {
    //     value: '财务中心',
    //     fontSize: 13,
    //     color:'#4b4b4b'
    //   },
    //   icon: {
    //     src: `${config.path.static}/img/tab-bar/office/caiwu.png`,
    //     activeSrc: `${config.path.static}/img/tab-bar/office/caiwu-a.png`,
    //     style: 'width:23px;',
    //     direction: 'top'
    //   },
    //   to() {
    //     this.$axios.get('/member/Lianmeng/check_user_role').then((res) => {
    //       //console.log(res)
    //       /*if(data.status == 0){
    //         $toast({
    //           message: data.info,
    //           duration: 3000
    //         });
    //         return false;
    //       }else{
    //         location.href = `${programUrl['gou-wu-bao']}/servers/money/index`;
    //       }*/
    //     });
    //   },
    //   className: 'bc-pd-5'
    // },
      {
      content: {
        value: '综合办公室',
        fontSize: 13,
        color:'#4b4b4b'
      },
      icon: {
        src: `${config.path.static}/img/tab-bar/office/office.png`,
        activeSrc: `${config.path.static}/img/tab-bar/office/office-a.png`,
        style: 'width:23px;',
        direction: 'top'
      },
      to() {
        location.href = `${programUrl['gou-wu-bao']}/member/lianmeng/lm_center.html`;
      },
      className: 'bc-pd-5'
    },
    //   {
    //   content: {
    //     value: '课程活动',
    //     fontSize: 10
    //   },
    //   icon: {
    //     src: `${config.path.static}/img/tab-bar/office/home.png`,
    //     activeSrc: `${config.path.static}/img/tab-bar/office/home-a.png`,
    //     style: 'width:20px;height:20px;',
    //     direction: 'top'
    //   },
    //   to() {
    //     //location.href = `${config.path.base}`;
    //     location.href = `${programUrl['gou-wu-bao']}/enroll/index/course_activity`;
    //   },
    //   className: 'bc-pd-5'
    // },
      {
      content: {
        value: '个人中心',
        fontSize: 13,
        color:'#4b4b4b'
      },
      icon: {
        src: `${config.path.static}/img/tab-bar/office/grzx.png`,
        activeSrc: `${config.path.static}/img/tab-bar/office/grzx-a.png`,
        style: 'width:23px;',
        direction: 'top'
      },
      to() {
        location.href = `${programUrl['gou-wu-bao']}/member`;
      },
      className: 'bc-pd-5'
    }]
  },
  active() {
    if (router.matchRoutes([
      /^\/member\/creator/,    //组件路由
      /^\/member\/product-angel/,    //组件路由
      /^\/member\/owner/,    //组件路由

    ])) {
      this.activeIndex = 2;
    } else if (router.matchRoutes([
      /^\/member\/vip/,    //组件路由
      /^\/member\/tools/,    //组件路由
    ])) {
      this.activeIndex = 4;
    } else if (router.matchRoutes([
      /^\/member\/agent\//,    //组件路由
      /^\/member\/area-creator/,    //组件路由
      /^\/member\/producers/,    //组件路由
      /^\/member\/branch-school/,    //组件路由
      /^\/member\/service-providers/,    //组件路由
      /^\/member\/commercial-college/,    //组件路由
    ])) {
      this.activeIndex = -1;
    } else {
      this.activeIndex = 0;
    }
  }
};

export default officeTabBar;